export default [{
	titulo: 'Pokémons',
	icone: 'menu-icon fa fa-caret-right',
	url: '/app/pokemons',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]